/**
 * API Configuration
 *
 * This module provides environment configuration for API services.
 * It reads from Vite's import.meta.env which is available at runtime.
 * For Jest tests, this file is mocked via moduleNameMapper.
 */

// Access Vite's environment variables
// @ts-expect-error - import.meta.env is injected by Vite
const env = import.meta.env;

export const API_BASE_URL: string = env?.VITE_API_BASE_URL || 'https://api.cedarheightsmusicacademy.com';
export const USE_MOCK_DATA: boolean = env?.VITE_USE_MOCK_DATA === 'true';
export const API_TIMEOUT: number = 30000; // 30 seconds
